import React from "react";
import { Star, ShieldCheck, MapPin, Users } from "lucide-react";

export default function AboutUs() {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* --- OUR STORY --- */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Story</h2>
            <p className="text-gray-600 mb-4 leading-relaxed">
              Founded in the heart of Dubai, <strong>Highend Holidays Homes</strong> was born from a simple belief: travel should not just be about visiting a place, but about living it in style.
            </p>
            <p className="text-gray-600 mb-4 leading-relaxed">
              We manage a curated collection of exclusive properties in Dubai's most prestigious locations, including Palm Jumeirah, Downtown Dubai, and Dubai Marina. Our homes are more than just rentals; they are sanctuaries designed for discerning travelers who seek the comfort of home with the luxury of a 5-star hotel.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Whether you are here for a short business trip or a long family vacation, our dedicated team ensures every detail is perfect, from fresh linens to 24/7 concierge support.
            </p>
          </div>
          <div className="relative">
            <img 
              src="/assets/images/burj/1.jpg" 
              alt="Luxury Interior" 
              className="rounded-2xl shadow-xl w-full h-[400px] object-cover"
            />
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-lg hidden md:block">
              <p className="text-4xl font-bold text-[#003580] mb-1">500+</p>
              <p className="text-sm text-gray-500 font-medium">Happy Guests</p>
            </div>
          </div>
        </div>
      </div>

      {/* --- WHY CHOOSE US --- */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900">Why Choose Us</h2>
            <p className="text-gray-500 mt-2">Experience the difference with Highend Holidays</p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            <FeatureCard 
              icon={<Star className="text-yellow-500" size={32} />}
              title="Premium Quality"
              desc="Hand-picked properties furnished to the highest standards."
            />
            <FeatureCard 
              icon={<MapPin className="text-blue-600" size={32} />}
              title="Prime Locations"
              desc="Stay in the most desirable neighborhoods in Dubai."
            />
            <FeatureCard 
              icon={<ShieldCheck className="text-green-600" size={32} />}
              title="Secure & Safe"
              desc="24/7 security and strict hygiene protocols for your peace of mind."
            />
            <FeatureCard 
              icon={<Users className="text-purple-600" size={32} />}
              title="Dedicated Support"
              desc="Our concierge team is available around the clock to assist you."
            />
          </div>
        </div>
      </div>

    </div>
  );
}

function FeatureCard({ icon, title, desc }) {
  return (
    <div className="p-6 bg-gray-50 rounded-xl text-center hover:shadow-md transition duration-300">
      <div className="flex justify-center mb-4">{icon}</div>
      <h3 className="text-lg font-bold text-gray-900 mb-2">{title}</h3>
      <p className="text-sm text-gray-600">{desc}</p>
    </div>
  );
}